// extracted by mini-css-extract-plugin
export default {"header":"header-uH3614mX","editable":"editable-mDYhZ88V","identity":"identity-nGhPMLp5","icon":"icon-MUoxd56i","username":"username-dEsnTm_y","editIcon":"editIcon-eanw3BEw"};